<template>
    <div class="base-user">
        <BaseAvatar
            class="base-user__image"
            :image="image"
        />
        <div>
            <div v-if="title" class="base-user__title">{{ title }}</div>
            <div class="base-user__subtitle">
                <slot name="subtitle">{{ subtitle }}</slot>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: null
    },
    subtitle: {
        type: String,
        default: null
    },
    image: {
        type: String,
        default: null
    }
});
</script>

<style src="./BaseUser.less" lang="less"></style>
